<template>
  <el-popover v-bind="$attrs" v-on="$listeners" trigger="hover" popper-class="wechat-share" :width="200">
    <template slot="reference"></template>
    <slot slot="reference"></slot>
    <div>
      <canvas ref="qrCode"></canvas>
      <div class="share-name">微信扫一扫</div>
      <div class="share-divider" data-content="分享到"></div>
      <div class="share-logo">
        <YorkbbsImage class="share-logo__item" :src="require('@/assets/images/common/wechat.png')"></YorkbbsImage>
        <YorkbbsImage class="share-logo__item" :src="require('@/assets/images/common/friend.png')"></YorkbbsImage>
      </div>
    </div>
  </el-popover>
</template>
<script>
import QRCode from 'qrcode';
export default {
  name: 'WechatSharePopover',
  mounted() {
    this.createQrcode();
  },
  methods: {
    /**
     * 生成二维码
     */
    createQrcode() {
      QRCode.toCanvas(this.$refs.qrCode, location.href, { width: 120, margin: 0 });
    },
  },
};
</script>
<style lang="scss" scoped>
.share-name {
  font-size: 16px;
  line-height: 20px;
  color: var(--text-color-3);
  margin-top: 10px;
  margin-bottom: 10px;
}
.share-divider {
  font-size: 14px;
  line-height: 17px;
  padding: 1em 0;
  color: var(--text-color-9);
  position: relative;
  overflow: hidden;
  margin-bottom: 8px;
  &::before {
    content: attr(data-content);
    position: absolute;
    padding: 0 1ch;
    line-height: 1px;
    border: solid #eee;
    border-width: 0 99vw;
    width: fit-content;
    white-space: nowrap;
    left: 50%;
    transform: translateX(-50%);
  }
}
.share-logo {
  display: flex;
  justify-content: center;
}
.share-logo__item {
  width: 25px;
  height: 25px;
  &:last-child {
    margin-left: 20px;
  }
}
</style>
<style lang="scss">
.wechat-share {
  box-sizing: border-box;
  text-align: center;
  padding-top: 25px;
  padding-bottom: 15px;
}
</style>
